// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*style overrides to accommodate forms with comments*/
.public-page-body .body-content {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./../Page.3.vue","webpack://./public/pages/Page.3.vue"],"names":[],"mappings":"AAAA,qDAAqD;ACErD;EACI,UAAA;ADAJ","sourcesContent":["/*style overrides to accommodate forms with comments*/\n.public-page-body .body-content {\n  padding: 0;\n}\n","\n/*style overrides to accommodate forms with comments*/\n.public-page-body .body-content {\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
